module.exports = __webpack_public_path__ + "static/media/id12-right_call-full.d8052bbb.jpg";